import React from 'react';
import useStyles from 'apps/Pdf/components/common/styles/Title';

interface Props {
  children: React.ReactNode;
}

const Title = (props: Props) => {
  const classes = useStyles();
  const { children } = props;

  return <h1 className={`pdfTitle colorLight ${classes.root}`}>{children}</h1>;
};

export default Title;
